export default __webpack_public_path__ + "static/media/bookr.8e216d68.png";